import { library, IconPack, IconDefinition  } from "@fortawesome/fontawesome-svg-core";
import {
  faSave,
  faCopy,
  faHands,
  faCalendarAlt,
  faSyncAlt,
  faCheckSquare,
  faStickyNote,
  faTruck,
  faTruckLoading,
  faEnvelope,
  faCaretUp,
  faCaretDown,
  faCog,
  faDownload,
  faEdit,
  faFilter,
  faMusic,
  faMinusCircle,
  faPlusCircle,
  faQuestionCircle,
  faTimesCircle,
  faUserCircle,
  faCertificate,
  faSearch,
  faDollarSign,
  faSearchLocation,
  faFileImage,
  faColumns,
  faStopwatch,
  faPrint,
  faFileExport,
  faBan,
  faCheckCircle,
  faSlidersH,
  faListAlt,
  faPencilAlt,
  faEye,
  faMapMarkedAlt,
  faCalculator,
  faLayerGroup,
  faClock,
  faEllipsisH,
  faSpinner,
  faUserCheck,
  faUndo,
  faSortNumericUp,
  faFileImport,
  faTrashRestore,
  faPhone,
  faPhoneSlash,
  faMapMarker,
  faArrowLeft,
  faArrowRight,
  faMap,
  faClipboard,
  faExclamationTriangle,
  faStar,
  faInfo,
  faInfoCircle,
  faPallet,
  fas,
  faLock,
  faLockOpen,
  faAngleUp,
  faAngleDown,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faBarcode,
  faLink,
  faBoxes

} from '@fortawesome/free-solid-svg-icons'

library.add(
  faSave as IconDefinition,
  faCopy as IconDefinition,
  faHands as IconDefinition,
  faCalendarAlt as IconDefinition,
  faSyncAlt as IconDefinition,
  faCheckSquare as IconDefinition,
  faStickyNote as IconDefinition,
  faTruck as IconDefinition,
  faTruckLoading as IconDefinition,
  faEnvelope as IconDefinition,
  faCaretUp as IconDefinition,
  faCaretDown as IconDefinition,
  faCog as IconDefinition,
  faDownload as IconDefinition,
  faEdit as IconDefinition,
  faFilter as IconDefinition,
  faMusic as IconDefinition,
  faMinusCircle as IconDefinition,
  faPlusCircle as IconDefinition,
  faQuestionCircle as IconDefinition,
  faTimesCircle as IconDefinition,
  faUserCircle as IconDefinition,
  faCertificate as IconDefinition,
  faSearch as IconDefinition,
  faDollarSign as IconDefinition,
  faSearchLocation as IconDefinition,
  faFileImage as IconDefinition,
  faColumns as IconDefinition,
  faStopwatch as IconDefinition,
  faPrint as IconDefinition,
  faFileExport as IconDefinition,
  faBan as IconDefinition,
  faCheckCircle as IconDefinition,
  faSlidersH as IconDefinition,
  faListAlt as IconDefinition,
  faPencilAlt as IconDefinition,
  faEye as IconDefinition,
  faMapMarkedAlt as IconDefinition,
  faCalculator as IconDefinition,
  faLayerGroup as IconDefinition,
  faClock as IconDefinition,
  faEllipsisH as IconDefinition,
  faSpinner as IconDefinition,
  faUserCheck as IconDefinition,
  faUndo as IconDefinition,
  faSortNumericUp as IconDefinition,
  faFileImport as IconDefinition,
  faTrashRestore as IconDefinition,
  faPhone as IconDefinition,
  faPhoneSlash as IconDefinition,
  faMapMarker as IconDefinition,
  faArrowLeft as IconDefinition,
  faArrowRight as IconDefinition,
  faMap as IconDefinition,
  faClipboard as IconDefinition,
  faExclamationTriangle as IconDefinition,
  faStar as IconDefinition,
  faInfo as IconDefinition,
  faInfoCircle as IconDefinition,
  faPallet as IconDefinition,
  fas as IconPack,
  faLock as IconDefinition,
  faLockOpen as IconDefinition,
  faAngleUp as IconDefinition,
  faAngleDoubleDown as IconDefinition,
  faAngleDoubleUp as IconDefinition,
  faBarcode as IconDefinition,
  faLink as IconDefinition,
  faBoxes as IconDefinition
)
